module.exports = __webpack_public_path__ + "static/media/mob_alert_partner_silver_x1.6550e99d.png";